module.exports = __webpack_public_path__ + "static/media/2_pl.ba4df706.png";